import { c as _c } from "react/compiler-runtime";
// Tremor Raw Label [v0.0.1]
import * as LabelPrimitives from "@radix-ui/react-label";
import React from "react";
import { cx } from "@/lib/tailwind-utils";
interface LabelProps extends React.ComponentPropsWithoutRef<typeof LabelPrimitives.Root> {
  disabled?: boolean;
  mandatory?: boolean;
}
const Label = React.forwardRef<React.ElementRef<typeof LabelPrimitives.Root>, LabelProps>((t0, forwardedRef) => {
  const $ = _c(16);
  let className;
  let disabled;
  let mandatory;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      disabled,
      mandatory,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = disabled;
    $[3] = mandatory;
    $[4] = props;
  } else {
    className = $[1];
    disabled = $[2];
    mandatory = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== disabled) {
    t1 = cx("inline-flex flex-row items-center text-sm leading-none", "text-foreground", {
      "text-foreground-muted": disabled
    }, className);
    $[5] = className;
    $[6] = disabled;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== mandatory) {
    t2 = mandatory && <span className="ml-1 text-status-error-text">*</span>;
    $[8] = mandatory;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== disabled || $[11] !== forwardedRef || $[12] !== props || $[13] !== t1 || $[14] !== t2) {
    t3 = <LabelPrimitives.Root ref={forwardedRef} className={t1} aria-disabled={disabled} {...props}>{props.children}{" "}{t2}</LabelPrimitives.Root>;
    $[10] = disabled;
    $[11] = forwardedRef;
    $[12] = props;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
});
Label.displayName = "Label";
export { Label };